import React from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'

const DiscountPercentageFlag = (props) => {
  const { listInstallments } = props

  function getPercentage () {
    const firstArray = listInstallments[0].valorParcela
    const secondArray = listInstallments[1].valorParcela * 2

    const calcDiscount = (secondArray - firstArray) / secondArray * 100
    const discount = Math.round(calcDiscount)

    return discount
  }

  return props.onlyCash ? (
    listInstallments.length > 2 ? (
      getPercentage() > 2 && (<div className='percentage-discount-content'>
        <div className='percentage-discount'>
          <p className='percentage-discount-value txt-body-sm txt-font-body-bold color-brand-4' aria-label={`${getPercentage()}% off`}>
            {getPercentage()}% off
          </p>
        </div>
      </div>)
    ) : ('')
  ) : ''
}

DiscountPercentageFlag.propTypes = {
  listInstallments: propTypes.object,
  onlyCash: propTypes.bool
}
const mapStateToProps = ({ onlyCash }) => ({ onlyCash })

export default connect(
  mapStateToProps,
  null
)(DiscountPercentageFlag)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetailColumn/DetailSection/DiscountPercentageFlag/DiscountPercentageFlag.js